export default "__VITE_ASSET__Dg8kIi53__"